var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app__banner",style:({ backgroundImage: ("url(" + _vm.bannerUrl + ")") })},[_c('h2',{staticClass:"app__banner-title"},[_vm._v("Raport Przejrzystości "+_vm._s(_vm.reportYear))])])}
var staticRenderFns = []

export { render, staticRenderFns }